import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { compose, withProps } from 'recompose';


import { querySelector } from '../../../utils';
import queryMetaHandler from '../../../utils/queryMetaHandler';
import omitProps from '../../../utils/omitProps';

export const JobApprovalInboxFragment = gql`
  fragment JobApprovalInboxFragment on Job {
    id
    state
    job_number
    all_reviewed
    has_unreview_reasons
    job_unreview_reasons {
      id
      unreviewed_by {
        id
        fullname
      }
      reason
    }
    earliest_date {
      month
      day
    }
    hasTimeEntries: has_time_entries
    tickets {
      edges {
        node {
          id
          ticket_number {
            id
            document {
              id
            }
          }
        }
      }
    }
    ticket_count
    departments {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`;

const JobApprovalInbox = gql`
  query JobApprovalInbox($currentDistrictId: Int, $currentDepartmentId: Int) {
    all_jobs(state: staged, date_order: asc, department_id: $currentDepartmentId, district_id: $currentDistrictId) {
      edges {
        node {
          ...JobApprovalInboxFragment
        }
      }
    }
  }
  ${JobApprovalInboxFragment}
`;


const mapDataToProps = withProps((props) => {
  const { data } = props;
  const jobs = querySelector(data, 'all_jobs.edges[*].node', []);
  return {
    jobs,
  };
});


const withData = graphql(
  JobApprovalInbox,
  {
    options: { fetchPolicy: 'network-only' },
  },
);


const enhance = compose(
  withData,
  queryMetaHandler,
  mapDataToProps,
  omitProps(['data']),
);


export default enhance;
